/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.product-recommendations--parent');
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        // Sem resultado na primeira busca (por exemplo, sem complementares cadastrados), tenta a reserva
        if (!(recommendations && recommendations.innerHTML.trim().length) && this.dataset.urlReserva) {
          this.dataset.url = this.dataset.urlReserva;
          delete this.dataset.urlReserva;
          this.fetchProducts();
          return;
        }

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');
            if (document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          }
          this.initializeSwiper();
          this.initializeSwiperRecommendations();
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }

  connectedCallback() {
    this.fetchProducts();
  }

  initializeSwiper() {
    const container = this.querySelector('.swiper-complementary');
    if (!container) return;

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      navigation: {
          nextEl: container.querySelector('.swiper-button-next-complementary-carousel'),
          prevEl: container.querySelector('.swiper-button-prev-complementary-carousel'),
      
      },
      pagination: {
        el: '.swiper-pagination-complementary',
        clickable: true,
      },
      breakpoints: {
        360: { slidesPerView: 1.1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 4 }
      },
    });
  }


  initializeSwiperRecommendations() {
    const container = this.querySelector('.swiper-recommendations');
    if (!container) return;

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next-recommendations-carousel'),
        prevEl: container.querySelector('.swiper-button-prev-recommendations-carousel'),
    },
    pagination: {
      el: '.swiper-pagination-recommendations',
      clickable: true,
    },
      breakpoints: {
        360: { slidesPerView: 1.1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 4 }
      },
    });
  }
}



customElements.define('product-recommendations', ProductRecommendations);
